import { render } from "./portafoglio.vue?vue&type=template&id=5c7f3c3a&ts=true"
import script from "./portafoglio.vue?vue&type=script&lang=ts"
export * from "./portafoglio.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__